(() => {
  const root = document.querySelector(".help-page");
  if (!root) return;

  const handles = root.dataset.handles.split(",").map(s => s.trim()).filter(Boolean);

  // Préfixe du marché courant ("" sur le marché principal, "/en-us", "/en"...)
  const rootUrl = (root.dataset.rootUrl || "/").replace(/\/+$/, "");
  const pageUrl = (handle) => `${rootUrl}/pages/${handle}`;
  const titleSuffix = document.title.includes(" | ") ? " | " + document.title.split(" | ").slice(1).join(" | ") : "";

  const left = document.getElementById("HelpTabsLeft");
  const right = document.getElementById("HelpTabsRight");
  const panel = document.getElementById("HelpPanel");
  const panelInner = panel.querySelector(".help-panel-inner");
  const motifMetaContainer = document.getElementById("HelpHandlesMotifs");
  const motifMap = new Map();
  const labelMap = new Map();
  if (motifMetaContainer) {
    motifMetaContainer.querySelectorAll("[data-handle]").forEach((node) => {
      const handle = node.dataset.handle ? node.dataset.handle.trim() : "";
      if (!handle) return;
      const url = node.dataset.motifUrl ? node.dataset.motifUrl.trim() : "";
      const css = node.dataset.motifCss ? node.dataset.motifCss.trim() : "";
      let overlayValue = "";

      if (url && url.trim() !== "") {
        overlayValue = `url("${url}")`;
      } else if (css && css.trim() !== "") {
        overlayValue = css.trim();
      }

      if (overlayValue !== "") {
        motifMap.set(handle, overlayValue);
      }

      if (node.dataset.label) {
        labelMap.set(handle, node.dataset.label);
      }
    });
  }

  const motifStyle = document.createElement("style");
  motifStyle.dataset.helpSliderMotifs = "";
  document.head.appendChild(motifStyle);

  const cssEscape = (value) => value.replace(/(["\\])/g, "\\$1");

  const refreshMotifRules = () => {
    const rules = [];

    handles.forEach((handle) => {
      const value = motifMap.get(handle);

      if (value && value.trim() !== "") {
        rules.push(`
        .help-tab-wrapper[data-handle="${cssEscape(handle)}"]::before {
          background: ${value} !important;
        }
      `);
      } else {
        rules.push(`
        .help-tab-wrapper[data-handle="${cssEscape(handle)}"]::before {
          background: none !important;
          background-image: none !important;
        }
      `);
      }
    });

    motifStyle.textContent = rules.join("\n");
  };

  refreshMotifRules();

  const TAB_W_MD = 30;  // = width desktop tabs (md)
  const TAB_W_LG = 60;  // = width desktop tabs (lg)
  const isDesktop = () => matchMedia("(min-width: 768px)").matches;
  const isLarge = () => matchMedia("(min-width: 1024px)").matches;
  const tabWidth = () => (isLarge() ? TAB_W_LG : TAB_W_MD);

  const localePrefixes = ["/fr-fr", "/en-us", "/en"];

  const stripLocalePrefix = (path) => {
    let clean = path;
    for (const prefix of localePrefixes) {
      if (clean.startsWith(prefix)) {
        const rest = clean.slice(prefix.length);
        const remains = rest.startsWith("/") ? rest : rest === "" ? "" : `/${rest}`;
        clean = remains === "" ? "/" : remains;
        break;
      }
    }
    return clean;
  };

  const updateLanguageSwitcherLinks = () => {
    const cleanPath = stripLocalePrefix(window.location.pathname);
    document.querySelectorAll('.language-link[data-lang-prefix]').forEach((link) => {
      const prefix = link.dataset.langPrefix || "";
      if (!prefix) return;
      link.href = `${prefix}${cleanPath}`;
    });
  };

  const handleFromPath = () => {
    const m = location.pathname.match(/\/pages\/([^/?#]+)/);
    return m ? m[1] : null;
  };

  const indexOf = (h) => handles.indexOf(h);

  function applyWrapperBackground(wrapper) {
    wrapper.removeAttribute("style");
  }

  function renderTabs() {
    const current = handleFromPath();
    const currentIndex = indexOf(current);

    left.innerHTML = "";
    right.innerHTML = "";

    handles.forEach((h, idx) => {
      if (h === current) return;

      const a = document.createElement("a");
      a.href = pageUrl(h);
      a.className = "help-tab";
      a.dataset.handle = h;

      // côté gauche/droite selon l’ordre
      const side = idx < currentIndex ? "left" : "right";
      a.dataset.side = side;

      a.textContent = labelMap.get(h) || h.replace(/-/g, " ");

      const wrapper = document.createElement("div");
      wrapper.className = "help-tab-wrapper";
      const trimmedHandle = h.trim();
      wrapper.dataset.handle = trimmedHandle;
      wrapper.dataset.side = side;
      wrapper.appendChild(a);
      applyWrapperBackground(wrapper, trimmedHandle);
      (side === "left" ? left : right).appendChild(wrapper);
    });

    if (current) {
      const currentWrapper = document.createElement("div");
      currentWrapper.className = "help-tab-wrapper help-tab-wrapper--current";
      currentWrapper.dataset.handle = current;
      currentWrapper.dataset.side = "right";

      const currentLink = document.createElement("a");
      currentLink.href = pageUrl(current);
      currentLink.className = "help-tab";
      currentLink.dataset.handle = current;
      currentLink.dataset.side = "right";
      currentLink.setAttribute("aria-current", "page");
      currentLink.textContent = labelMap.get(current) || current.replace(/-/g, " ");

      currentWrapper.appendChild(currentLink);
      applyWrapperBackground(currentWrapper, current);
      right.prepend(currentWrapper);
    }
  }

  function applyDesktopOffsets(activeIndex) {
    if (!isDesktop()) {
      panelInner.style.width = "";
      panelInner.style.marginLeft = "";
      return;
    }

    const qty = handles.length;
    const w = tabWidth();

    // équivalent React:
    // width: calc(100vw - tabQuantity * tabWidth)
    panelInner.style.width = `calc(100vw - ${qty * w}px)`;

    // React: marginLeft: (tabQuantity - index - index) * tabWidth
    // => (qty - 2*index) * w
    panelInner.style.marginLeft = `${(qty - 2 * activeIndex) * w}px`;
  }

  const cache = new Map();

  const sectionId = (root.closest(".shopify-section")?.id || "").replace(/^shopify-section-/, "");

  async function fetchHTML(url) {
    const res = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
    if (!res.ok) throw new Error("Fetch failed");
    const tmp = document.createElement("div");
    tmp.innerHTML = await res.text();
    return tmp;
  }

  async function fetchFragment(handle) {
    // Le rendu de section inclut les blocs FAQ saisis dans l'éditeur, absents du template help-ajax.
    let frag = null;
    if (sectionId) {
      try {
        frag = (await fetchHTML(`${pageUrl(handle)}?section_id=${sectionId}`)).querySelector(".help-panel");
      } catch (e) {}
    }
    if (!frag) {
      frag = (await fetchHTML(`${pageUrl(handle)}?view=help-ajax`)).querySelector(".help-ajax-fragment");
    }
    if (!frag) throw new Error("Missing help fragment");

    const content = frag.querySelector(".help-content-container");
    if (!content) throw new Error("Missing .help-content-container");

    return content.outerHTML; // IMPORTANT: on garde le wrapper
  }

  function ensureFragment(handle) {
    if (cache.has(handle)) {
      return Promise.resolve(cache.get(handle));
    }

    return fetchFragment(handle).then((html) => {
      cache.set(handle, html);
      return html;
    });
  }

  function animateTabMovement(handle, side) {
    const tab = document.querySelector(`.help-tab-wrapper[data-handle="${handle}"]`);
    if (!tab) return Promise.resolve();
    const animationClass = side === "left" ? "moving-left" : "moving-right";
    tab.classList.add(animationClass);
    return new Promise((resolve) => {
      const onEnd = (e) => {
        if (e.propertyName !== "transform") return;
        tab.removeEventListener("transitionend", onEnd);
        tab.classList.remove(animationClass);
        resolve();
      };
      tab.addEventListener("transitionend", onEnd);
    });
  }

  async function go(handle, { push = true, side = "right" } = {}) {
    const i = indexOf(handle);
    if (i === -1) {
      location.href = pageUrl(handle);
      return;
    }

    const nextHTML = await ensureFragment(handle);

    // 1) Préparation : on coupe les transitions et on met l'état initial
    panel.classList.add("is-prep");
    panel.classList.remove("enter-from-left", "enter-from-right", "is-entering");

    panel.classList.add(side === "left" ? "enter-from-left" : "enter-from-right");

    // 2) Injecter uniquement dans l'inner (structure stable)
    panelInner.innerHTML = nextHTML;

    // offsets desktop
    applyDesktopOffsets(i);

    // 3) Force reflow pour “valider” l’état initial
    void panel.offsetHeight;

    // 4) Lancer l’anim : on réactive les transitions + état final
    panel.classList.remove("is-prep");
    requestAnimationFrame(() => {
      panel.classList.add("is-entering");
    });

    // 5) Nettoyage après transition (sinon la prochaine fois ça peut re-snap)
    const onEnd = (e) => {
      if (e.propertyName !== "transform") return;
      panel.removeEventListener("transitionend", onEnd);
      panel.classList.remove("enter-from-left", "enter-from-right");
      // on garde is-entering (ou tu peux l’enlever si tu préfères)
    };
    panel.addEventListener("transitionend", onEnd);

    if (push) history.pushState({ handle }, "", pageUrl(handle));
    panel.dataset.handle = handle;
    const pageLabel = labelMap.get(handle) || handle.replace(/-/g, " ");
    document.title = pageLabel + titleSuffix;
    renderTabs();
    updateLanguageSwitcherLinks();
    // keep cache warm for remaining handles
    prefetchFragments(handle);
  }

  function prefetchFragments(active) {
    handles.forEach((handle) => {
      if (handle === active) return;
      ensureFragment(handle).catch(() => { });
    });
  }

  // Click
  root.addEventListener("click", (e) => {
    const wrapper = e.target.closest(".help-tab-wrapper");
    if (!wrapper) return;
    const handle = wrapper.dataset.handle;
    const side = wrapper.dataset.side || "right";
    const a = wrapper.querySelector("a.help-tab");
    e.preventDefault();
    if (!handle) {
      if (a?.href) {
        location.href = a.href;
      }
      return;
    }
    go(handle, { side }).catch(() => {
      if (a?.href) {
        location.href = a.href;
      }
    });
  });
  // Back/forward
  window.addEventListener("popstate", () => {
    const h = handleFromPath();
    if (!h) return;

    const prev = panel.dataset.handle;
    const side = indexOf(h) < indexOf(prev) ? "left" : "right";

    go(h, { push: false, side }).catch(() => location.reload());
  });
  // Init
  const currentHandle = handleFromPath();
  if (currentHandle) {
    cache.set(currentHandle, panelInner.innerHTML);
  }
  renderTabs();
  updateLanguageSwitcherLinks();
  applyDesktopOffsets(indexOf(currentHandle));
  prefetchFragments(currentHandle);
  window.addEventListener("resize", () => applyDesktopOffsets(indexOf(handleFromPath())));
})();